import { BKBNThemeWrapper } from 'components/common/BKBNThemeWrapper'
import { FC } from 'react'
import { WorkspaceCreationController } from './WorkspaceCreation.controller'

export const WorkspaceCreationPage: FC = () => {

  return (
    <BKBNThemeWrapper>
      <WorkspaceCreationController />
    </BKBNThemeWrapper>
  )
}
